export default function PHP_MySQLCreateTable() {
  return (
    <div>
      <h1>PHP_MySQLCreateTable</h1>
    </div>
  );
}
